export var vkClientId = process.env.VK_CLIENT_ID || '7820755';
export var yandexClientId = process.env.YANDEX_CLIENT_ID || '94ff8f10e0f7481a9ca3bbc399b64d40';
export var googleClientId = process.env.GOOGLE_CLIENT_ID || '139939264673-92e6lhj4lcejo2kens9l7an79o6so7hh.apps.googleusercontent.com';
export var stravaClientId = process.env.STRAVA_CLIENT_ID || '66356';
export var polarClientId = process.env.POLAR_CLIENT_ID || '40196971-edcb-49be-bf03-9ecd2d1a84a8';
export var telegramBotId = process.env.TELEGRAM_BOT_ID || '6253684924';
